<!-- <h4>PS Score Alert Details</h4>
<div>
    <p class="bold" *ngFor="let message of messages">{{message}}</p>
</div>
<div class="dialog-action-button" mat-dialog-actions>
    <button mat-button mat-dialog-close>Ok</button>
</div> -->

<h5>PS Score Alert Details</h5>
<div class="wrapper">
    <mat-nav-list>
        <div *ngFor="let message of messages">
            <span mat-list-item><b>{{message}}</b></span>
        </div>
    </mat-nav-list>
</div>
<div class="dialog-action-button" mat-dialog-actions>
    <button mat-button mat-dialog-close>Ok</button>
</div>
